import React from "react"
// import { Link } from "gatsby"
import "../pages/mystyles.scss"


export default function Footer({ children }) {
    return (
        <>

<footer className="footer mt-6 has-text-light">
<div className="container">
    <div className="hero is-warning mb-6 ">
        

<p className="title is-5 has-text-centered p-6 is-family-sans-serif">Also from the NUS East Asian Institute via NUS Press: <a href="http://nuspress.nus.edu.sg/collections/china-an-international-journal-1" className=" navlink">China: An International journal</a></p>

      
    </div>
    <div className="columns is-family-sans-serif">
<div className="column is-2">
<h3 className="title is-5 has-text-light"><span>Other books from NUS Press: by Subject</span></h3>
										<div className="module-ct">
												<ul>
	  <li><a href="http://nuspress.nus.edu.sg/collections/anthropology" className=" navlink">Anthropology</a></li>
      <li><a href="http://nuspress.nus.edu.sg/collections/archaeology" className=" navlink">Archaeology</a></li>
      <li><a href="http://nuspress.nus.edu.sg/collections/architecture-building" className=" navlink">Architecture & Building</a></li>
      <li><a href="http://nuspress.nus.edu.sg/collections/business" className=" navlink">Business</a></li>
      <li><a href="http://nuspress.nus.edu.sg/collections/economics" className=" navlink">Economics</a></li>
      <li><a href="http://nuspress.nus.edu.sg/collections/geography" className=" navlink">Geography</a></li>
      <li><a href="http://nuspress.nus.edu.sg/collections/history" className=" navlink">History</a></li>
      <li><a href="http://nuspress.nus.edu.sg/collections/language-textbooks" className=" navlink">Language Learning</a></li>
      <li><a href="http://nuspress.nus.edu.sg/collections/language-literature" className=" navlink">Literature & Linguistics</a></li>
      <li><a href="http://nuspress.nus.edu.sg/collections/medicine-life-sciences" className=" navlink">Medicine & Life Sciences</a></li>
      <li><a href="http://nuspress.nus.edu.sg/collections/man-and-nature" className=" navlink">Man & Nature</a></li>
      <li><a href="http://nuspress.nus.edu.sg/collections/maritime-history" className=" navlink">Maritime History</a></li>
      <li><a href="http://nuspress.nus.edu.sg/collections/memoirs" className=" navlink">Memoirs</a></li>
      <li><a href="http://nuspress.nus.edu.sg/collections/politics-international-relations" className=" navlink">Politics & International Relations</a></li>
      <li><a href="http://nuspress.nus.edu.sg/collections/religion" className=" navlink">Religion</a></li>
      <li><a href="http://nuspress.nus.edu.sg/collections/sociology" className=" navlink">Sociology</a></li>  
      <li><a href="http://nuspress.nus.edu.sg/collections/visual-culture-art-history" className=" last  navlink">Visual Arts & Visual Culture</a></li>
												</ul>
										</div>
</div>

<div className="column is-2">



<h3 className="title is-5 has-text-light"><span>Other books from NUS Press: by Place</span></h3>
										<div className="module-ct">
											
										
												<ul>
												<li><a href="http://nuspress.nus.edu.sg/collections/singapore" className=" navlink">Singapore</a></li>
      <li><a href="http://nuspress.nus.edu.sg/collections/malaysia" className=" navlink">Malaysia</a></li>
      <li><a href="http://nuspress.nus.edu.sg/collections/indonesia" className=" navlink">Indonesia</a></li>
      <li><a href="http://nuspress.nus.edu.sg/collections/philippines" className=" navlink">Philippines</a></li>
      <li><a href="http://nuspress.nus.edu.sg/collections/mainland-southeast-asia" className=" navlink">Mainland Southeast Asia</a></li>
      <li><a href="http://nuspress.nus.edu.sg/collections/southeast-asia" className=" navlink">Southeast Asia</a></li>      
      <li><a href="http://nuspress.nus.edu.sg/collections/rest-of-asia-regional" className=" last  navlink">Regional / Rest of Asia</a></li>
												</ul>
											
										</div>
                                        <div className="module-inner">
										<h3 className="title is-5 mt-6 has-text-light"><span>Journals</span></h3>
										<div className="module-ct">
											
											<ul>
    <li><a href="http://nuspress.nus.edu.sg/collections/china-an-international-journal-1" className=" navlink">China: An International Journal</a></li>     
      <li><a href="http://nuspress.nus.edu.sg/collections/southeast-of-now-directions-in-contemporary-and-modern-art" className=" last  navlink">Southeast of Now: Directions in Contemporary and Modern Art</a></li>
											</ul>
										</div>
									</div>
</div>

<div className="column is-2">

<h3 className="title is-5 has-text-light"><span>About Us</span></h3>
										<div className="module-ct">
											<ul>
     <li><a href="http://nuspress.nus.edu.sg/pages/about-us" className="current  navlink">The NUS Press Story</a></li>
      <li><a href="http://nuspress.nus.edu.sg/blogs/news" className=" navlink">Latest News</a></li>
      <li><a href="http://nuspress.nus.edu.sg/pages/why-publish-with-nus-press" className=" navlink">Why Publish with NUS Press</a></li>
      										</ul>
										</div>
									
										<h3 className="title is-5 has-text-light mt-6"><span>Contact Us</span></h3>
										<div className="module-ct">
											<ul>
 
      <li><a href="http://nuspress.nus.edu.sg/pages/contact-us" className=" navlink">Contact Details</a></li>
      <li><a href="http://nuspress.nus.edu.sg/pages/jobs" className=" navlink">Employment Opportunities</a></li>
      <li><a href="http://nuspress.nus.edu.sg/pages/prospective-authors" className=" navlink">For Prospective Authors</a></li>
      <li><a href="http://nuspress.nus.edu.sg/pages/distributors" className=" last  navlink">Our Distributors</a></li>
											</ul>
										</div>
									

    
</div>



<div className="column is-6">
<div className="module-inner">
											
                                            <div className="module-ct">
												<div>
                                                <h3 className="title is-5 has-text-light">License</h3>
												<a rel="license" href="http://creativecommons.org/licenses/by-nc-nd/4.0/"><img alt="Creative Commons License" src="https://i.creativecommons.org/l/by-nc-nd/4.0/88x31.png" /></a><br /> This web version of Innovation and China's Global Emergence is based on the book published by NUS Press in August 2021, and licensed under a <a rel="license" href="http://creativecommons.org/licenses/by-nc-nd/4.0/">Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International License</a>.<br /></div>
											</div>
										</div>
<div className="module-inner">
											<h3 className="title is-4 mt-6 has-text-light"><span>National University of Singapore Press Pte Ltd</span></h3>
											<div className="module-ct">
												<ul className="nus-contact-us">
													<li><span className="icon"><i className="fas fa-address-card"></i></span>3 Arts Link, #03-01-02, Singapore 117569</li>
													<li><span className="icon"><i className="fas fa-phone"></i></span>+65 6776 1148</li>
													<li><span className="icon"><i className="fas fa-envelope"></i></span><a href="mailto:nusbooks@nus.edu.sg">nusbooks@nus.edu.sg</a></li>
												
                                                </ul>

                                                <div className="mt-6">
													<a href="https://www.facebook.com/NUS-Press-334903343263621/" target="_blank"><img src="facebook.png" alt="Facebook Icon" width="40" height="40" /></a>&nbsp;
                                                   &nbsp;&nbsp;&nbsp;
													<a href="https://twitter.com/NUS_Press" target="_blank"><img src="twitter.png" alt="twitter" width="40" height="40" /></a>&nbsp;
												</div>
												
											</div>
										</div>
									
										
									


</div>

    </div>
    




  </div>
  

</footer>


        </>
        )
      }